import { render, staticRenderFns } from "./newTeacher.vue?vue&type=template&id=21ac25d3"
import script from "./newTeacher.vue?vue&type=script&lang=js"
export * from "./newTeacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports